export default "__VITE_ASSET__aLso4ukh__"